<form [formGroup]="form" (ngSubmit)="add()">
  <mat-form-field appearance="fill" class="program-category-chip-list">
    <mat-label>{{ 'program_category.add.label' | translate }}</mat-label>
    <input matInput formControlName="categoryName" type="text" [attr.maxlength]="categoryMaxLength">
  </mat-form-field>
  <div formArrayName="categories">
    <div cdkDropList class="category-list" (cdkDropListDropped)="drop($event)">

      @for (category of categories; track category; let i = $index) {
        <div
          [formGroupName]="i"
        [ngClass]="{
          'category-box': true,
          'draggable': (isAdmin$ | async),
          'owner': selectedOUId === category.organization_unit_id
        }"
          cdkDrag
          [cdkDragDisabled]="(isAdmin$ | async) ? false : !(hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) || (selectedOUId !== category.organization_unit_id)"
          >
          @if (i === inlineEditingIndex) {
            <mat-form-field appearance="outline" class="program-category-inline-edit">
              <input matInput autofocus [formControl]="editingCategoryControl" type="text" [attr.maxlength]="categoryMaxLength">
            </mat-form-field>
            <button mat-icon-button (click)="update(category)" type="button" [attr.aria-label]="'program_category.update.label' | translate">
              <mat-icon>save</mat-icon>
            </button>
          }
          @if (i !== inlineEditingIndex) {
            <span>
              {{category.name}}
              @if (selectedOUId !== category.organization_unit_id) {
                &nbsp;<span class="category-owner">{{category.organization_unit_name}}</span>
              }
            </span>
            @if (selectedOUId === category.organization_unit_id) {
              <div class="category-btn-container">
                <button (click)="setEditingIndex(i)" type="button" mat-icon-button [attr.aria-label]="'program_category.edit.label' | translate">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="removeCategory(category)" type="button" [attr.aria-label]="'program_category.remove.label' | translate">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</form>
